import { Link } from 'react-router-dom';

interface GameCardProps {
  slug: string;
  name: string;
  image: string;
  category: string;
  rating: number;
  players: string;
}

export default function GameCard({ slug, name, image, category, rating, players }: GameCardProps) {
  return (
    <Link
      to={`/article/pg-guanwang-xinshou-zhinan`}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={image}
          alt={`${name} - PG官网热门游戏`}
          title={`${name} - PG官网正版游戏`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
            {category}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">{name}</h3>
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            <span className="text-foreground-700 font-medium">{rating}</span>
          </div>
          <div className="flex items-center gap-1 text-foreground-500">
            <i className="ri-user-line text-sm"></i>
            <span>{players}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}